export const objectKeys = <Obj extends object>(obj: Obj): (keyof Obj)[] =>
  Object.keys(obj) as (keyof Obj)[]

export const objectValues = <Obj extends object>(obj: Obj): Obj[keyof Obj][] =>
  Object.values(obj) as Obj[keyof Obj][]

export const objectEntries = <Obj extends object>(obj: Obj): [keyof Obj, Obj[keyof Obj]][] =>
  Object.entries(obj) as [keyof Obj, Obj[keyof Obj]][]
